__turbopack_context__.v({
  "browseAllButton": "HeroSearch-module__dU5kYa__browseAllButton",
  "noResults": "HeroSearch-module__dU5kYa__noResults",
  "resultBrand": "HeroSearch-module__dU5kYa__resultBrand",
  "resultInfo": "HeroSearch-module__dU5kYa__resultInfo",
  "resultItem": "HeroSearch-module__dU5kYa__resultItem",
  "resultTitle": "HeroSearch-module__dU5kYa__resultTitle",
  "searchButton": "HeroSearch-module__dU5kYa__searchButton",
  "searchContainer": "HeroSearch-module__dU5kYa__searchContainer",
  "searchFieldWrapper": "HeroSearch-module__dU5kYa__searchFieldWrapper",
  "searchInput": "HeroSearch-module__dU5kYa__searchInput",
  "searchResults": "HeroSearch-module__dU5kYa__searchResults",
  "searchRow": "HeroSearch-module__dU5kYa__searchRow",
  "searchWrapper": "HeroSearch-module__dU5kYa__searchWrapper",
  "visible": "HeroSearch-module__dU5kYa__visible",
});
